export enum AccommodationSwitches {
  EnvCertification = "EnvCertification",
  PreferredChoice = "PreferredChoice"
}
